<template>
  <div class="about-card">
    <div class="about-card_content">
      <p class="paragraph">{{ $t('Хотите регулярно пополнять игровой бюджет и получать золото на свой игровой аккаунт, не тратя для этого ни дополнительных средств, ни особых усилий? Тогда у нас есть для вас отличные новости! С сегодняшнего дня вы сможете оплачивать свои привычные покупки с помощью специальной карты «Мира кораблей», и часть потраченных средств будет возвращаться на ваш игровой аккаунт в виде золота.') }}
      </p>
      <p class="paragraph">{{ $t('Закажите карту «Мира кораблей», и она сама начнёт пополнять вашу игровую «копилку»!') }}</p>

      <ul class="about-card_cards-list">
        <li class="about-card_card-item">
          <CardPicture
            :design="design"
            :game="games.MK"
          />
        </li>
      </ul>
    </div>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Как это работает?') }}</h2>
      <p class="paragraph" v-html="orderLocalizedLink"/>
      <p class="paragraph">
        {{ $t('Оплачивайте картой свои ежедневные расходы: покупки в магазинах, коммунальные услуги, мобильную связь, интернет и т. д.') }}
      </p>
      <p class="paragraph">
        {{ $t('В начале каждого месяца бесплатно получайте на свой игровой аккаунт различные игровые бонусы и пакеты с золотом, размер которых зависит от суммы, потраченной с карты за прошедший месяц.') }}
      </p>
    </ExpandCollapse>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Какие бонусы даёт карта?') }}</h2>
      <ol class="ordered-list">
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Стартовый бонус') }}</h3>
          <p class="paragraph">{{ $t('30 дней премиум аккаунта вы получите в подарок вместе с первым возвратом золота.') }}</p>
          <p class="paragraph">{{ $t('Начисляется единоразово на аккаунт с первой заказанной картой.') }}</p>
        </li>
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Ежемесячный бонус') }}</h3>
          <ol class="unordered-list">
            <li class="unordered-list_item">{{ $t('25 золота будут возвращаться вам на игровой аккаунт за каждые 3 BYN, потраченные с карты') }}
            </li>
          </ol>
        </li>
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Бонус в Премиум магазине') }}</h3>
          <p class="paragraph">{{ $t('При оплате в Премиум магазине с помощью метода «Карта Леста» вам будет возвращаться в виде золота 5% от стоимости каждого купленного товара. И это в дополнение к ежемесячному возврату золота, который распространяется в том числе и на покупки в Премиум магазине.') }}
          </p>
        </li>
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Дополнительный бонус') }}</h3>
          <p class="paragraph">{{ $t('Пользуясь картой, кроме золота вы также будете получать следующие дополнительные бонусы каждый месяц:') }}
          </p>
          <ol class="unordered-list">
            <li class="unordered-list_item">{{ $t('По 20 расходуемых бонусов "Серебро +20%", "Опыт корабля +100%", "Опыт командира +100%", "Свободный опыт +300%";') }}
            </li>
            <li class="unordered-list_item">{{ $t('По 10 расходуемых бонусов "Серебро +160%", "Опыт корабля +800%", "Опыт командира +800%", "Свободный опыт +2400%";') }}
            </li>
          </ol>
        </li>
      </ol>
    </ExpandCollapse>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Как бесплатно пополнять карту?') }}</h2>
      <p class="paragraph" v-html="depositLocalizedLink" />
    </ExpandCollapse>

    <ul class="about-card_action">
      <li class="about-card_button">
        <OrderButton game="mk" />
      </li>
      <li class="about-card_link">
        <a :href="getLearnMoreUrl('mk')" class="link link__button" target="_blank">
          {{ $t('Узнать больше') }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import AboutCardBase from '../AboutCardBase.vue'
import ExpandCollapse from '@/common/components/ExpandCollapse/ExpandCollapse.vue'
import OrderButton from '@/components/OrderButton'
import CardPicture from '@/components/Card/CardPicture.vue'

@Component({
  components: { OrderButton, ExpandCollapse, CardPicture }
})
class AboutCardMkByAlfa extends AboutCardBase {
  get depositLocalizedLink () {
    return this.$t(
      'Бесплатное пополнение карты с карт других банков %(link_start)sпо ссылке%(link_stop)s.',
      { link_start: this.depositLink.linkStart, link_stop: this.depositLink.linkStop }
    )
  }

  get benefitsLocalizedLink () {
    return this.$t(
      'И это далеко не всё! Весь список преимуществ — %(link_start)sздесь%(link_stop)s.',
      { link_start: this.benefitsLink.linkStart, link_stop: this.benefitsLink.linkStop }
    )
  }

  get orderLocalizedLink () {
    return this.$t(
      '%(link_start)sЗакажи%(link_stop)s карту «Мира кораблей» и %(link_start_bind)sпривяжи%(link_stop_bind)s карту к игровому аккаунту.',
      {
        link_start: this.orderLinkBY.linkStart,
        link_stop: this.orderLinkBY.linkStop,
        link_start_bind: this.bindLink.linkStart,
        link_stop_bind: this.bindLink.linkStop
      }
    )
  }
}

export default AboutCardMkByAlfa
</script>

<style lang="scss" src="../about-card.scss"></style>
